import React, {useContext} from "react";
import {ShopContext} from "./Providers/ShopContext";
import {useParams} from "react-router-dom";
import BreadCrum from "./BreadCrum";
import ProductDisplay from "./ProductDisplay";
import DescriptionBox from "./DescriptionBox";
import Related from "./Related";

const Products = () => {
  const {all_product} = useContext(ShopContext);
  const {productId} = useParams();
  const product = all_product.find((e) => e.id === Number(productId));

  return (
    <div>
      <BreadCrum product={product} />
      <ProductDisplay product={product} />
      <DescriptionBox />
      <Related />
    </div>
  );
};

export default Products;
